import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Container, QuestionText, QuestionCount, ImageContainer } from './QuestionCard.styled';

import highlight from '@/assets/highlight.svg';
import { useReviewQuestionsResume, useReviewQuestionsStore } from '@/store';

export const QuestionCard = () => {
  const { questionReviewResume = [] } = useReviewQuestionsResume();
  const { selectedContent } = useReviewQuestionsStore();

  const { t } = useTranslation('StudentQuizTranslations');
  const navigateTo = useNavigate();

  const hasSelectedContent = selectedContent.length > 0;

  const handleReview = async () => {
    navigateTo('/tests/review/mode');
  };

  const selectedQuestions = () => {
    return questionReviewResume
      .flatMap(course => course.sections)
      .reduce((acum, content) => {
        if (selectedContent.includes(content._id)) acum += content.totalQuestions;
        return acum;
      }, 0);
  };

  return (
    <Container>
      <QuestionText>
        <ImageContainer>
          <img src={highlight} alt="highlight" />
        </ImageContainer>
        <QuestionCount>{selectedQuestions()}</QuestionCount> {t('REVIEW_MODE_QUESTIONS')}
      </QuestionText>
      <Button disabled={!hasSelectedContent} type="primary" onClick={handleReview} block>
        {t('REVIEW_MODE_START_BUTTON')}
      </Button>
    </Container>
  );
};
